const PartnerSuccess = () => {
    return (
        <div className="mt-5 p-5 bg-light border rounded">
            <p className="font-weight-bold">
                RefineAI's Partner Success Module
            </p>
            <p>
                This module is currently under development.
            </p>
        </div>
    );
}


export default PartnerSuccess;
